import {sbxCoreService} from "../Network";

import {IShipmentSearch} from "../Store/Pickup/Types";
import Pickup from "../Models/Pickup";
import {getBaseModel, isPresent} from "../Utils/Utils";
import NewPickup from "../Models/NewPickup";
import PickupTypes from "../Models/PickupTypes";
import {SwitchFilters} from "../Store/Filter/Types";
const MODEL = "pickup"

const defaultToFetch = [
  'contact_call',
  'contact_call.customer',
  'contact_pickup',
  'packing_type',
  'address.city',
  'address.zone',
  'paying_customer',
  'payment_type',
  'vehicle.driver'
];

export function getPickups(customer: string, filters: SwitchFilters) {

  let query = sbxCoreService.with(MODEL);

  if(customer.length) {
     query = query.andWhereIsEqualTo('paying_customer', customer)
       .andWhereIsNotEqualTo('status', PickupTypes.CANCELADA)
       .andWhereIsNotEqualTo('status', PickupTypes.RECOGIDA);
  }

  if(isPresent(filters)) {
    query.newGroupWithAnd();
  }
  if(Boolean(filters?.shippingPending)) {
    query.orWhereIsEqualTo('status',PickupTypes.PENDIENTE)
  }
  if(Boolean(filters?.shippingSchedule)) {
    query.orWhereIsEqualTo('status',PickupTypes.AGENDADA)
  }

  return query.fetchModels(defaultToFetch).loadAll(defaultToFetch);
}

export function updatePickup(pickup: Pickup) {
  return sbxCoreService.with(MODEL).update({...getBaseModel(pickup)});
}

export function savePickup(pickup: NewPickup) {
  return sbxCoreService.with(MODEL).insert(pickup);
}

export function getPickupsByClient(key: string) {
  const toFetch = [
    'address.city',
    'address.zone',
  ];

  return sbxCoreService.with(MODEL)
    .andWhereIsEqualTo("paying_customer", key)
    .fetchModels(toFetch)
    .loadAll(toFetch)
}

export function getShipmentsByPickup(params: IShipmentSearch) {

  const toFetch = [
    "receiver",
    "receiver.city",
    "customer_payment_type",
    "group",
    "subgroup",
  ];

  let query = sbxCoreService.with("shipment")
    .andWhereIsEqualTo("pickup", params.pickup);

  if (params.name && params.name.trim() !== "") {
    query = query.andWhereItContains("receiver.name", params.name);
  }

  if (params.last_name && params.last_name.trim() !== "") {
    query = query.andWhereItContains("receiver.last_name", params.last_name);
  }

  if (params.phone && params.phone.trim() !== "") {
    query = query.andWhereItContains("receiver.phone", params.phone);
  }

  return query
    .fetchModels(toFetch)
    .loadAll(toFetch);
}

export function deleteShipment(key: string) {
  return sbxCoreService.with("shipment").whereWithKeys([key]).delete();
}

export function getUnitsByShipment(key: string) {
  return sbxCoreService.with("units")
    .andWhereIsEqualTo("shipment",key)
    .loadAll();
}
